import React from 'react';
import { BaseFeature } from '@meitu/saas-editor-ui/es/collapses/image-enhance-collapse/base/base';
import { editor } from '@/instance';
import { ICardMenuProps } from '../../type';
import { useEnhanceOperateHelper } from '../hooks/use-enhance-helper';

const BaseEnhance: React.FC<ICardMenuProps> = ({
    onToggle,
    onReset,
    onSlider,
    featureType,
    curType,
    setCurType,
    trackFunc,
}) => {
    const enhanceOperate = useEnhanceOperateHelper({
        onSlider(type: string) {
            // 滑块完成
            onSlider?.(featureType, type);
        },
        onReset() {
            // 重置
            onReset?.(featureType);
        },
    });

    return <BaseFeature editor={editor} {...enhanceOperate} trackFunc={trackFunc} />;
};

export default React.memo(BaseEnhance);
